/* eslint-disable require-jsdoc */
/**
 * Offer class.
 */
import { CuriosityCorruption } from "./ResearchModels/CuriosityCorruption";
import { DemographicInsights } from "./ResearchModels/DemographicInsights";
import { ExistingSolutions } from "./ResearchModels/ExistingSolutions";
import { ResearchDisplaySettiings } from "./ResearchModels/ResearchDisplaySettings";
export class Research {
    constructor() {
        this.demographicInsights = new DemographicInsights();
        this.existingSolutions = new ExistingSolutions();
        this.curiosityCorruption = new CuriosityCorruption();
        this.extraNotes = "";
        this.displaySettings = new ResearchDisplaySettiings();
    }
}
